import moment from 'moment';
import { dateConfig } from '../configureApp';

export const removeTimeZoneFromDate = (value) => {
  if (typeof value !== 'string') {
    return value;
  }
  if (!isNaN(Number(value))) {
    return value;
  }
  const date = moment(value);
  if (date.isValid()) {
    const localDate = moment(date).format(dateConfig.dateTimeString);
    return localDate;
  }
  return value;
};

export const combineDateTime = (date, time) => {
  if (moment(date).isValid() === false) {
    return '';
  }
  return `${moment(date).format(dateConfig.dateString)} ${time ? moment(time).second(0).format(dateConfig.timeString) : ''}`;
};

export const currentDate = () =>
  moment().format(dateConfig.dateString);

export const toDateStringOnly = (date) => {
  if (moment.isMoment(date)) {
    return date.format(dateConfig.dateString);
  }
  if (moment(date).isValid() === false) {
    return '';
  }
  return moment(date).format(dateConfig.dateString);
};

export const convertDateForMappingQuestion = (dateString) => {
  if (!dateString) {
    return '';
  }
  return moment(dateString).format(dateConfig.dateString);
};

export const convertTimeForMappingQuestion = (dateString) => {
  if (!dateString) {
    return '';
  }
  return moment(dateString).format(dateConfig.timeFormat);
};

export const getNZDateTime = () => {
  const now = new Date();
  const nzDateString = now.toLocaleString('en-US', { timeZone: 'Pacific/Auckland' });
  return moment(nzDateString);
};


// WEBPACK FOOTER //
// ./app/utils/dateUtil.js